import { TCurrentEnvValues } from '~/shared/helpers/getEnvironment'

export const getCurrentEnv = () =>
  (document.querySelector('meta[name="current-env"]') as HTMLMetaElement)
    .content as TCurrentEnvValues
